import { Title, Link, MaskCpf } from "@funcional/react-ui";
import { GridView, DefaultColumnFilter } from "@funcional/react-table-ui";
import { useBeneficiaries } from "@pbm/beneficiaries/hooks";
import { IBeneficiary } from "@pbm/beneficiaries/contracts";
import { useMemo } from "react";
import { Column } from "react-table";
import { FormattedDate } from "react-intl";
import { useHistory } from "react-router-dom";

interface CellProps {
  value: any;
  row: { original: IBeneficiary };
}

export default function ListBeneficiaryPage() {
  const history = useHistory();

  const showRecord = (row: any) =>
    history.push(`/pbm/beneficiaries/${row.original.id}`);

  const columns: Column<IBeneficiary>[] = useMemo(
    () => [
      {
        Header: "CPF",
        accessor: "customerCode",
        Filter: DefaultColumnFilter,
        Cell: ({ row: { original } }: CellProps) => (
          <Link to={`/pbm/beneficiaries/${original.id}`}>
            <MaskCpf value={original.customerCode} />
          </Link>
        ),
      },
      {
        Header: "Cadastro",
        accessor: "createdAt",
        Cell: ({ value }) => (
          <span title={value}>
            <FormattedDate value={value} />
          </span>
        ),
      },
    ],
    []
  );

  return (
    <>
      <Title>Beneficiários</Title>

      <GridView<IBeneficiary>
        paginated
        showRecord={showRecord}
        columns={columns}
        hook={useBeneficiaries}
      />
    </>
  );
}
